







































































































import { RoleType } from "@/shared/types";
import { Vue, Component } from "@/shared/vuepack";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useEmployerRolePermissionStore } from "@/admin/store/employerRolePermission";
import { Validator } from "vee-validate";
import { useUserStore } from "@/shared/store/user";

const dict = {
  custom: {
    Roles: {
      required: "User must have at least one role assigned."
    }
  }
};

@Component({ components: {} })
export default class CreateAdminUser extends Vue {
  $validator: Validator;
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  employerRolePermissionStore = useEmployerRolePermissionStore();
  isSubmitting = false;

  roleOptions = this.employerRolePermissionStore.allRoles.map(x => {
    return { value: x.roleId, text: x.roleName };
  });
  adminUser = {
    firstName: "",
    lastName: "",
    employeeId: null,
    username: "",
    email: "",
    phoneNumber: ""
  };
  selectedRoles = [];

  get isRolePermissionsEnabled () {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions;
  }

  get isFeatureFlagAvailable () {
    return this.featureFlagStore.featureFlagsAvailable;
  }

  mounted (): void {
    this.employerRolePermissionStore.getRolesByType(RoleType.Admin);
    this.$validator.localize("en", dict);
  }

  onSubmit () {
    if (this.isSubmitting) return;

    this.$validator.validate().then(valid => {
      if (valid) {
        this.isSubmitting = true;
        // call save action
        this.userStore.createAdminUser({
          ... this.adminUser, email: this.adminUser.username, assignedRoles: this.selectedRoles
        }).then(resp => {
          if (resp) {
          // after the call succeeds route back to user management page
          this.$router.push("/admin-users/admin-user-management");
          }
        }).finally(() => {
          this.isSubmitting = false;
        });
      }
      });
  }

  onCancel () {
    this.$router.push("/admin-users/admin-user-management");
  }
}
